import { Link } from "react-router-dom";
import { imageUrl } from "@/lib/api";
import { MapPin, Tag, Gift } from "lucide-react";
import VerifiedBadge from "@/components/VerifiedBadge";
import SaveButton from "@/components/SaveButton";

export default function ListingCard({ listing }) {
  const img = listing.images?.[0];
  return (
    <div className="relative">
      <div className="absolute top-3 right-3 z-10">
        <SaveButton type="listing" id={listing.id} size="icon" />
      </div>
      <Link
        to={`/marketplace/${listing.id}`}
        data-testid={`listing-card-${listing.id}`}
        className="abm-card overflow-hidden flex flex-col fade-in"
      >
      <div className="relative aspect-[4/3] bg-[#F0EBDC] overflow-hidden">
        {img ? (
          <img src={imageUrl(img)} alt={listing.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#C05A3D] font-display text-3xl">ABM</div>
        )}
        <div className="absolute top-3 left-3 abm-chip !bg-white/85">
          <Tag className="w-3 h-3" /> {listing.category}
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display text-lg leading-tight text-[#1A1A1A] line-clamp-2">{listing.title}</h3>
          <div className="shrink-0 text-right">
            {listing.is_free ? (
              <span className="inline-flex items-center gap-1 text-[#1E3A2F] font-semibold">
                <Gift className="w-4 h-4" /> Free
              </span>
            ) : (
              <span className="font-semibold text-[#C05A3D]">${Number(listing.price || 0).toFixed(0)}</span>
            )}
          </div>
        </div>
        <p className="mt-2 text-sm text-[#5C5C5C] line-clamp-2">{listing.description}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-[#5C5C5C]">
          <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {listing.location || "Washington"}</span>
          <div className="inline-flex items-center gap-2">
            {listing.owner_verified && <VerifiedBadge tier={listing.owner_verification_tier} size="sm" />}
            <span className="text-[#1E3A2F]">{listing.condition}</span>
          </div>
        </div>
      </div>
    </Link>
    </div>
  );
}
